import { writable } from "svelte/store";

export const chatMessages = writable<Array<any>>([]);
